<template>
  <div class="right-drawer">
   
    <v-navigation-drawer v-model="isOpen" app right temporary >
            <v-toolbar flat>
                <v-toolbar-title>{{
                    translations.generalSettings[lang]
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="isOpen = false">
                    <v-icon>{{ icons.mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list dense nav v-if="navMenu && navMenu[0] && navMenu[0].to">
                <v-list-item
                    v-for="(item, i) in navMenu"
                    :key="i"
                    link
                    color="secondary"
                    :to="item.to"
                >
                    <v-list-item-icon class="mr-2">
                        <v-icon color="secondary">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content style="overflow: visible;">
                        <v-list-item-title>{{
                            item.name
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
      </div>
</template>
  
<script>
import translations from "@/utils/translations/global";
import { mapActions, mapState, mapMutations } from "vuex";


import {
    mdiClose,
    mdiCashMultiple,
    mdiXml,
    mdiCartOutline,
    mdiShoppingOutline
} from "@mdi/js";

export default {
name: "GeneralSettings",
props: {

  value: {
            type: Boolean
        },
},

mixins: [translations],

data() {
    return {
      rightDrawer: false,
        icons: {
            mdiClose,
            mdiCashMultiple,
            mdiXml,
            mdiCartOutline,
            mdiShoppingOutline
        },
      }
    },
    computed: {
        ...mapState(["permissions", "storePermissions", "superUser", "store", "panelType"]),
      
        lang() {
                return this.$route.params.lang;
            },
        isOpen: {
          get() {
            return this.value;
          },
          set(v) {
            this.$emit('input', v)
          }
        },

        navMenu() {
          let menu = []
          if (this.superUser || this.permissions.general_settings && this.storePermissions.general_settings && this.getPermission('general_settings.billing_dashboard.read')) {
            menu.push({
              name: this.translations.billingDashboard[this.lang],
              icon: this.icons.mdiCashMultiple,
              to: `/${this.lang}/${this.panelType}/general-settings/billing-dashboard`
            })
          }
          
          if(this.panelType == 'loyaltyPanel' ){
            if(this.superUser || this.permissions.developers && this.storePermissions.developers && this.getPermission('developers.read')){
              menu.push({
                name: this.translations.developers[this.lang],
                icon: this.icons.mdiXml,
                to: `/${this.lang}/${this.panelType}/general-settings/developers`
              })
            }
            // if(this.permissions.general_settings && this.storePermissions.general_settings && this.getPermission('roadcube_market.read')){
              menu.push({
                name: 'Roadcube Market',
                icon: this.icons.mdiShoppingOutline,
                to: `/${this.lang}/${this.panelType}/general-settings/roadcube-market`
              })
            // }
          } 
          return menu
        }
    },
    methods: {

      getPermission(path) {
            return this.superUser || (
                eval("this.permissions." + path) &&
                eval("this.storePermissions." + path)
            );
        },

    },
    created() {
      const component = this;
      this.handler = function (e) {
        component.$emit('keydown', e);
      }
      window.addEventListener('keydown', this.handler);
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.handler);
    }
  }
</script>
<style>
.right-drawer {
  /* top: 0 !important; */
  /* z-index: 100 !important; */
  position: relative;
  z-index: 8;
  float: right;
}
</style>  